// Canonical.js — met à jour le <link rel="canonical"> (et og:url) selon la ROUTE courante.
//
// Bug corrigé : index.html ne contenait qu'un canonical STATIQUE vers la racine "/", donc TOUTES
// les pages du SPA (/store, /videos, /channels…) se déclaraient canoniques vers l'accueil → Google
// les traitait comme des doublons et n'indexait qu'une page. Ici on pointe chaque route vers SA
// propre URL propre (sans query string → évite la démultiplication d'URLs paramétrées).
// Googlebot exécute le JS (et react-snap fige le rendu par route) → le bon canonical est pris en compte.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Canonical() {
  const { pathname } = useLocation();
  useEffect(() => {
    const base = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, '');
    const href = base + (pathname && pathname !== '/' ? pathname : '/');

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.setAttribute('rel', 'canonical'); document.head.appendChild(link); }
    link.setAttribute('href', href);

    // Aligne og:url sur le canonical (partages sociaux cohérents avec la page réelle).
    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.setAttribute('content', href);
  }, [pathname]);

  return null;
}
